var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.04924 16V14.1383C1.84749 14.0793 0.681917 13.7263 0 13.2951L0.538998 11.0009C1.29237 11.4511 2.34989 11.8632 3.51678 11.8632C4.539 11.8632 5.23878 11.432 5.23878 10.6479C5.23878 9.9024 4.66492 9.43127 3.33726 8.94108C1.4183 8.23557 0.108061 7.25519 0.108061 5.3535C0.108061 3.62759 1.22092 2.27517 3.13987 1.8631V0H4.89673V1.72591C6.09848 1.78498 6.90632 2.05794 7.4976 2.37235L6.97778 4.58844C6.51198 4.37312 5.68671 3.92104 4.39434 3.92104C3.22876 3.92104 2.85229 4.4703 2.85229 5.01956C2.85229 5.666 3.48017 6.07807 5.00479 6.70545C7.13856 7.5291 8 8.60714 8 10.3731C8 12.118 6.86972 13.6081 4.80741 14.0007V15.9995H3.04924V16Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollarIcon.598dbe67.svg";
export { ForwardRef as ReactComponent };